import translations from '../../../../translations';
import type { column } from '../../../../types/page';
import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';

const NUMBER_OF_ROWS = 5;

const DataGrid = ({ label, columns }: { label: string | null; columns: column[] | null }) => {
    if (!columns) {
        return <p>{translations.PAGE_BUILDER_no_columns}</p>;
    }

    const columnsToDisplay = columns
        .filter((column) => column.isDisplayValue)
        .sort((a, b) => a.order - b.order)
        .map((column) => (
            <th key={column.typeElementPropertyId} title={column.label ?? ''}>
                {column.label}
            </th>
        ));

    const cellsToDisplay = columns.map((column) => (
        <td key={`cell-${column.typeElementPropertyId}`}>-</td>
    ));

    const rowsToDisplay = [...new Array(NUMBER_OF_ROWS)].map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: No alternative to index
        <tr key={i}>{cellsToDisplay}</tr>
    ));

    return (
        <div data-testid="component-preview-datagrid" className="component-preview-table">
            <PreviewComponentLabel labelText={label || ''} />
            <table id="preview-datagrid">
                <thead>
                    <tr>{columnsToDisplay}</tr>
                </thead>
                <tbody>{rowsToDisplay}</tbody>
            </table>
        </div>
    );
};

export default DataGrid;
